enum BadgeType {
  DEFAULT = 'default',
  CAPSULE = 'capsule',
}
export default BadgeType;
